import { useEffect, useMemo, useRef } from "react";
import * as echarts from "echarts";
import type { EChartsOption } from "echarts";

export interface DashboardChartProps {
    option?: object;
    data?: unknown[];
    ariaLabel?: string;
}

/** 看板图表 React 实现，继续使用旧 Vue 的 ECharts option，确保坐标轴和图形一致。 */
export default function DashboardChart({ option, data, ariaLabel }: DashboardChartProps) {
    const containerRef = useRef<HTMLDivElement>(null);
    const chartOption = useMemo(() => {
        if (!data) return option || {};
        return {
            xAxis: { type: "category", data: data.map((_, index) => String(index + 1)) },
            yAxis: { type: "value" },
            series: [{ type: "bar", data: data.map(value => Number(value) || 0) }]
        };
    }, [data, option]);

    useEffect(() => {
        const element = containerRef.current;
        if (!element) return;
        const chart = echarts.init(element, null, { renderer: "svg" });
        chart.setOption(chartOption as EChartsOption, true);
        const observer = new ResizeObserver(() => chart.resize());
        observer.observe(element);
        return () => {
            observer.disconnect();
            chart.dispose();
        };
    }, [chartOption]);

    return <div ref={containerRef} className="dashboard-echart" role="img" aria-label={ariaLabel} />;
}
